@defer (when !production()) {
  <angular-query-devtools />
}
<p-toast />
<main class="main w-full h-full h-screen bg-white relative">
  <router-outlet></router-outlet>
</main>
